/**
 * AdminSubTabs – horizontal sub-navigation for admin screens (e.g. Item Management, System Admin).
 * Renders a tablist and the active tab's content. Styling: .admin-subtabs-container, .admin-subtab-button, .admin-tab-content-wrapper.
 */
export default function AdminSubTabs({ tabs, activeTab, onTabChange, tablistAriaLabel }) {
  return (
    <>
      <div className="admin-subtabs-container" role="tablist" aria-label={tablistAriaLabel}>
        {tabs.map(({ id, label, icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => onTabChange(id)}
            className={`admin-subtab-button ${activeTab === id ? 'active' : ''}`}
            aria-label={label}
            aria-selected={activeTab === id}
          >
            <i className={`fas ${icon} icon-md icon-primary`} aria-hidden="true" /> {label}
          </button>
        ))}
      </div>
      {tabs.map(({ id, content }) => (
        <div
          key={id}
          className="admin-tab-content-wrapper"
          style={{ display: activeTab === id ? 'block' : 'none' }}
        >
          {content}
        </div>
      ))}
    </>
  )
}
